import React from "react";
import bus from "../../assets/images/vehicle/bus.png";
import truck from "../../assets/images/vehicle/truck.png";
import car from "../../assets/images/vehicle/car.png";
import hups from "../../assets/images/vehicle/cpu.png";
import motorcycle from "../../assets/images/vehicle/motorcycle.png";
import rickshaw from "../../assets/images/vehicle/rickshaw.png";
import tractor from "../../assets/images/vehicle/tractor.png";
import eRickshaw from "../../assets/images/vehicle/cycleRickshaw.png";
import genset from "../../assets/images/vehicle/generator.png";
import accumulator from "../../assets/images/vehicle/accumulator.png";
import { Link } from "react-router-dom";

function Vehical() {
  return (
    <div className="product-name">
      <Link to="/products/bus">
        <input
          className="vehicle-img"
          id="bus"
          type="image"
          src={bus}
          alt="bus"
        />
      </Link>
      <Link to="/products/truck">
        <input
          className="vehicle-img"
          id="truck"
          type="image"
          src={truck}
          alt="truck"
        />
      </Link>
      <Link to="/products/car">
        <input
          className="vehicle-img"
          id="car"
          type="image"
          src={car}
          alt="car"
        />
      </Link>
      <Link to="/products/bike">
        <input
          className="vehicle-img"
          id="a1"
          type="image"
          src={motorcycle}
          alt="motercycle"
        />
      </Link>
      <Link to="/products/rickshaw">
        <input
          className="vehicle-img"
          id="a2"
          type="image"
          src={rickshaw}
          alt="rickshaw"
        />
      </Link>
      <Link to="/products/tractor">
        <input
          className="vehicle-img"
          id="a3"
          type="image"
          src={tractor}
          alt="tractor"
        />
      </Link>
      <Link to="/products/eRickshaw">
        <input
          className="vehicle-img"
          id="a4"
          type="image"
          src={eRickshaw}
          alt="eRickshaw"
        />
      </Link>
      <Link to="/products/hups">
        <input
          className="vehicle-img"
          id="a5"
          type="image"
          src={hups}
          alt="hups"
        />
      </Link>
      <Link to="/products/genset">
        <input
          className="vehicle-img"
          id="a6"
          type="image"
          src={genset}
          alt="genset"
        />
      </Link>
      <Link to="/products/inverter">
        <input
          className="vehicle-img"
          id="a7"
          type="image"
          src={accumulator}
          alt="inverter"
        />
      </Link>
    </div>
  );
}
export default Vehical;
